export default "__VITE_ASSET__CPYyTZ9D__"